import {
  FORGOT_PASSWORD,
  LOGIN,
  REFRESH_TOKENS_API,
  REGENERATE_2FA,
  REGISTER,
  RESET_PASSWORD,
  VERIFY_2FA,
} from "../constants/api-path";
import httpClient from "./http.interceptor";
import { refreshHttpClient } from "./auth-session";

/**
 * @param {email: string, password:string} formData
 * @returns Promise<any>
 */
export const loginEmailPasswordAPI = (formData: any): Promise<any> => {
  return httpClient.post(LOGIN, formData);
};

/**
 * @param {fullName: string, email: string, password:string} formData
 * @returns Promise<any>
 */
export const registerUserAPI = (formData: any): Promise<any> => {
  return httpClient.post(REGISTER, formData);
};

/**
 * @param {email: string} formData
 * @returns Promise<any>
 */
export const forgotPasswordAPI = (formData: any): Promise<any> => {
  return httpClient.post(FORGOT_PASSWORD, formData);
};

/**
 * @param {token: string, password: string } formData
 * @returns Promise<any>
 */
export const resetPasswordAPI = (formData: any): Promise<any> => {
  return httpClient.post(RESET_PASSWORD, formData);
};

/**
 * @param {code: string, email: string } formData
 * @returns Promise<any>
 */
export const verify2faAPI = (formData: any): Promise<any> => {
  return httpClient.post(VERIFY_2FA, formData);
};

/**
 * @param {email: string } formData
 * @returns Promise<any>
 */
export const regenerate2faAPI = (formData: any): Promise<any> => {
  return httpClient.post(REGENERATE_2FA, formData);
};

/**
 * @param {refreshToken: string} formData
 * @returns Promise<any>
 */
/** Uses refresh-only HTTP client (no 401 interceptor loop). */
export const refreshToken = (formData: { refreshToken: string }): Promise<any> => {
  return refreshHttpClient
    .post(REFRESH_TOKENS_API, formData)
    .then((res) => res.data);
};
